import { BOOKING_API_URL } from '../../../lib/api/useApi';

export const makePublicContactUrl = (url = '') => {
  if (url.includes('http')) {
    return url;
  } else {
    return `${BOOKING_API_URL}${url}`
  }
}